import React from 'react';
import { PaperTradingDashboard } from '../components/paper-trading';

export default function PaperTrading() {
  return <PaperTradingDashboard />;
}
